<template>
    <div class="centerWidth">
        <!-- <div class="gaokao-nav">
            <span>个人中心 ></span>
            <span>升学途径选科测评 ></span>
            <span>开始测试</span>
        </div> -->
        <section class="gaokao-content">
            <div class="my-title">升学途径选科测评</div>
            <ul class="gkTest-step">
                <li>
                    <div class="step-con step-on flex zhong center">
                        <div>
                            <img src="../../../image/Eva-inf-aa.png" />
                            <span>基本信息</span>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="step-con flex zhong center"><img src="../../../image/Eva-arr-aa.png" /></div>
                </li>
                <li>
                    <div class="step-con flex zhong center">
                        <div>
                            <img src="../../../image/Eva-boy-a.png" />
                            <span>身体条件</span>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="step-con flex zhong center"><img src="../../../image/Eva-arr-a.png" /></div>
                </li>
                <li>
                    <div class="step-con flex zhong center">
                        <div>
                            <img src="../../../image/Eva-fam-a.png" />
                            <span>家庭条件</span>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="step-con flex zhong center"><img src="../../../image/Eva-arr-a.png" /></div>
                </li>
                <li>
                    <div class="step-con flex zhong center">
                        <div>
                            <img src="../../../image/Eva-per-a.png" />
                            <span>个人能力</span>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="step-con flex zhong center"><img src="../../../image/Eva-arr-a.png" /></div>
                </li>
                <li>
                    <div class="step-con flex zhong center">
                        <div>
                            <img src="../../../image/Eva-des-a.png" />
                            <span>个人意愿</span>
                        </div>
                    </div>
                </li>
            </ul>
            <p class="test-tit">请完成以下关于您的基本信息的题目</p>
            <article class="testTwo-con">
                <div
                    class="testTwo-list"
                    v-for="item in question"
                    :key="item.Id"
                >
                    <p
                        class="test-ctxt"
                        :class="{'empty-question': !item.notEmpty}"
                    >{{item.Sort}}.{{item.Title}}{{item.Remark}}</p>
                    <template v-if="item.Id === 7">
                        <div class="way-test">
                            <area-cascader
                                v-model="item.ContentList[0]"
                                :data="pcaa"
                            ></area-cascader>
                        </div>
                        <ul class="testTwo-ul">
                            <li>
                                <input
                                    type="radio"
                                    name="q7"
                                    :value="'城镇'"
                                    v-model="item.ContentList[1]"
                                />
                                <p>城市</p>
                            </li>
                            <li>
                                <input
                                    type="radio"
                                    name="q7"
                                    :value="'农村'"
                                    v-model="item.ContentList[1]"
                                />
                                <p>农村</p>
                            </li>
                        </ul>
                    </template>
                    <template v-if="item.Type === 1">
                        <ul class="testTwo-ul">
                            <li
                                v-for="answer in item.AnswerList"
                                :key="answer.Id"
                            >
                                <input
                                    type="radio"
                                    :name="'q' + item.Id"
                                    :value="answer.Option"
                                    v-model="item.Option"
                                />
                                <p>{{answer.Option}}.{{answer.Content}}</p>
                            </li>
                        </ul>
                    </template>
                    <template v-if="item.Type === 3 && item.FillQuestionAnswer.includes('3')">
                        <div class="way-test">
                            <el-date-picker
                                value-format="yyyy-MM-dd"
                                :editable="false"
                                v-model="item.Content"
                                type="date"
                                placeholder="请选择日期"
                            ></el-date-picker>
                        </div>
                    </template>
                    <template v-if="item.Id === 3">
                        <div class="way-test flex zhong">
                            <el-select
                                v-model="item.Content"
                                placeholder="请选择"
                            >
                                <el-option
                                    v-for="answer in item.AnswerList"
                                    :key="answer.Id"
                                    :label="answer.Content + '年'"
                                    :value="answer.Content"
                                ></el-option>
                            </el-select>
                        </div>
                    </template>
                </div>
            </article>
            <div class="test-btn">
                <button
                    class="gaokao-btn"
                    @click="goNext"
                >下一步</button>
            </div>
        </section>
    </div>
</template>

<script>
import 'vue-area-linkage/dist/index.css';
import { pca, pcaa } from 'area-data';
export default {
    props: {
        question: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    data() {
        return {
            // 生日
            birthday: '',
            sel: '',
            year: '',
            pca: pca,
            pcaa: pcaa,
            selected2: []
        };
    },
    created() {
    },
    methods: {
        // 下一步
        goNext() {
            this.$emit('next');
            // this.$router.push('/waytestb');
        }
    }
};
</script>

<style scoped>
.test-ctxt.empty-question {
    color: #ff1e00;
    font-weight: bold;
}

.gaokao-nav {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 20px 0;
}
.gaokao-nav span {
    font-size: 15px;
    color: #333;
}
.gaokao-nav span:last-child {
    color: #333;
}
/* gaokao-content */
.gaokao-content {
    padding: 0 20px;
    width: 100%;
    height: auto;
    overflow: hidden;
    background-color: #fff;
    margin-bottom: 25px;
}

.test-tit {
    font-size: 16px;
    color: #333;
    position: relative;
    padding-left: 20px;
    margin-bottom: 30px;
}
.test-tit::after {
    position: absolute;
    content: '';
    width: 0;
    height: 20px;
    left: 0;
    top: 50%;
    margin-top: -10px;
    border: 2px solid #333;
    border-radius: 50px;
}
/* testTwo-con */
.testTwo-con {
    width: 100%;
    height: auto;
    overflow: hidden;
}
.testTwo-list {
    width: 100%;
    height: auto;
}
.test-ctxt {
    font-size: 15px;
    color: #333;
    margin-bottom: 25px;
}
.testTwo-ul {
    padding: 0 30px;
    height: auto;
    overflow: hidden;
}
.testTwo-ul li {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 25px;
}
.testTwo-ul li input {
    margin-right: 15px;
}
.testTwo-ul li p {
    font-size: 15px;
    color: #333;
}
.test-btn {
    display: flex;
    align-items: center;
    justify-content: center;
}
.test-btn button {
    margin-left: 20px;
    margin-right: 20px;
}
.gkTest-step {
    padding: 40px;
}
.gkTest-step li {
    width: calc(100% / 9);
}
.way-test {
    padding: 0 30px;
    height: auto;
    margin-bottom: 25px;
}
.way-test span {
    font-size: 14px;
    color: #333;
    margin-left: 10px;
}
</style>
